import { render, staticRenderFns } from "./dueDate.vue?vue&type=template&id=0338f73d&scoped=true&"
import script from "./dueDate.vue?vue&type=script&lang=js&"
export * from "./dueDate.vue?vue&type=script&lang=js&"
import style0 from "./dueDate.vue?vue&type=style&index=0&id=0338f73d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0338f73d",
  null
  
)

export default component.exports